export default "__VITE_ASSET__17d60bfb__"